export default "__VITE_ASSET__df1194b4__"